(function () {
  var CUTOFF_HOUR = 14;

  // Reused across every tick instead of rebuilt each time — Intl.DateTimeFormat
  // construction does locale/ICU lookup work that's wasteful to repeat every 30s.
  var ukFormatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    weekday: 'short',
    hour12: false,
  });

  function pad(n) {
    return n < 10 ? '0' + n : n;
  }

  function getUKParts() {
    var map = {};
    ukFormatter.formatToParts(new Date()).forEach(function (part) {
      map[part.type] = part.value;
    });
    return {
      hour: parseInt(map.hour, 10) % 24,
      minute: parseInt(map.minute, 10),
      second: parseInt(map.second, 10),
      weekday: map.weekday,
    };
  }

  function update(el) {
    // Sold-out products (or a sold-out variant, on load - see the data-available attribute set in
    // sections/main-product.liquid) never get a dispatch estimate: this notice is purely time-of-
    // day driven otherwise and has no other way to know the product can't actually be ordered.
    if (el.dataset.available === 'false') return;

    var messageEl = el.querySelector('[data-dispatch-message]');
    var now = getUKParts();
    var isWeekday = now.weekday !== 'Sat' && now.weekday !== 'Sun';
    var nowSeconds = now.hour * 3600 + now.minute * 60 + now.second;
    var cutoffSeconds = CUTOFF_HOUR * 3600;

    if (isWeekday && nowSeconds < cutoffSeconds) {
      var remaining = cutoffSeconds - nowSeconds;
      var hours = Math.floor(remaining / 3600);
      var minutes = Math.floor((remaining % 3600) / 60);
      var label = hours > 0
        ? hours + 'h ' + pad(minutes) + 'm'
        : Math.max(minutes, 1) + ' minute' + (minutes === 1 ? '' : 's');
      messageEl.textContent = 'In stock — Order within ' + label + ' for same-day dispatch';
    } else {
      messageEl.textContent = 'In stock — Order now, ships next business day';
    }

    el.hidden = false;
  }

  document.querySelectorAll('[data-dispatch-countdown]').forEach(function (el) {
    update(el);
    setInterval(function () {
      update(el);
    }, 30000);
  });
})();
